import { get, post, deleteOne, put } from "@/modules/request";
import { PageRequest, PageResponse } from "@/types/api-types";
import { Collection, CollectionItem, CollectionType } from "@/types/collection";

// 获取合集列表
export const ApiGetCollectionPage = (
  params: PageRequest<{
    targetMateId: number;
    currentMateId?: number;
  }>
): Promise<PageResponse<Collection>> => {
  if (!params.pagination) params.pagination = { page: 1, perPage: 999 };
  if (!params.sort) params.sort = { field: "dtUpdate", order: "desc" };
  return get(`/CollectionPage`, params);
};

// 创建合集
export const ApiPostCollection = (data: Partial<Collection>) =>
  post(`/Collection`, data);

// 编辑合集
export const ApiPutCollection = (uuid: string, data: Partial<Collection>) =>
  put(`/Collection/${uuid}`, data);

// 获取合集详情
export const ApiGetCollection = (uuid: string) => get(`/Collection/${uuid}`);

// 删除合集
export const ApiDeleteCollection = (uuid: string) =>
  deleteOne(`/Collection/${uuid}`);

// 获取合集详情
export const ApiGetCollectionItemPage = (
  params: PageRequest<{
    collectionId?: number;
    collectableType?: CollectionType;
  }>
): Promise<PageResponse<CollectionItem>> => get(`/CollectionItemPage`, params);

export const ApiPostCollectionItem = (
  data: Pick<
    CollectionItem,
    "mateId" | "collectionId" | "collectableId" | "collectableType"
  >
) => post(`/CollectionItem`, data);

export const ApiPostCollectionItemCreateMany = (
  data: Pick<
    CollectionItem,
    "mateId" | "collectionId" | "collectableIdzz" | "collectableType"
  >
) => post(`/CollectionItem/CreateMany`, data);

export const ApiDeleteCollectionItem = (id: number) =>
  deleteOne(`/CollectionItem/${id}`);

export const ApiPostCollectionItemSortMany = (
  id: number,
  data: {
    direction: "up" | "down";
  }
) => post(`/CollectionItemSort/` + id, data);

export const ApiPostCollectionItemSort = (collectionId: number) =>
  post(`/CollectionItemSort`, { collectionId });

export const ApiGetCollectionReadPopularPage = (
  {
    tab,
    type,
    mateId,
    reviewStatus,
  }: {
    tab?: "hot" | "recommend";
    type?: number;
    mateId?: number;
    reviewStatus?: number; // 1.待审核 2.审核通过 3.审核不通过
  } = {},
  { page = 1, perPage = 999 } = {},
  { field = "dtUpdate", order = "desc" } = {}
) => {
  const params =
    tab === "hot"
      ? {
          tab,
          pagination: { page, perPage },
        }
      : {
          filter: { mateId, type, reviewStatus },
          sort: { field, order },
          pagination: { page, perPage },
        };
  return get("/Collection/ReadPopularPage", params);
};
